import type { Root } from 'mdast'
import type { ContainerDirective } from 'mdast-util-directive'
import { visit } from 'unist-util-visit'

/**
 * Remark plugin to support custom paragraph directives
 *
 * Usage in markdown:
 * :::paragraph{class="special"}
 * This is a special paragraph with custom styling.
 * :::
 *
 * Or with multiple classes:
 * :::paragraph{class="highlight mc-text--center"}
 * This paragraph has multiple classes.
 * :::
 *
 * The className will be passed to the div component,
 * allowing you to apply custom CSS classes to specific paragraphs.
 */
export function remarkParagraphDirective() {
  return (tree: Root) => {
    visit(tree, 'containerDirective', (node: ContainerDirective) => {
      if (node.name !== 'paragraph') return

      const data = node.data || (node.data = {})
      data.hName = 'div'

      const className = node.attributes?.class || node.attributes?.className
      if (className) {
        data.hProperties = {
          ...data.hProperties,
          className,
        }
      }
    })
  }
}
